import React, { useState, createContext } from "react";

const PopupContext = createContext({
  popupIsOpened: false,
  togglePopup: () => {},
  setPopupState: () => {},
});

export const PopupProvider = ({ children }) => {
  const [popupIsOpened, setPopupIsOpened] = useState(false);

  const togglePopup = () => setPopupIsOpened(prev => !prev);
  const setPopupState = (state) => setPopupIsOpened(state);

  return (
    <PopupContext.Provider value={{ popupIsOpened, togglePopup, setPopupState }}>
      {children}
    </PopupContext.Provider>
  );
};

export default PopupContext;
